'use strict';

function dashboardSharingTooltip () {
  return $(document.body).tooltip({
    selector: '.sharing-tooltip'
  });
}

module.exports = dashboardSharingTooltip;
